import type { NDateLocale } from './enUS'
import { ka } from 'date-fns/locale'

const dateKaGE: NDateLocale = {
  name: 'ka-GE',
  locale: ka
}

export default dateKaGE
